import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import internet from '@devices/settings/device_settings/internet.js';
import safety from '@devices/settings/device_settings/safety.js';
import plugs_app_settings from '@devices/settings/device_settings/plugs_app_settings.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellypluguk1',
	friendly_name: 'Plug UK',
	family: 'relay',
	isPM: true,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'forgotten_lights',
				'overtemperature',
			],
			control_holder: 0,
			settings: [
				timer,
				schedule,
				actions,
				internet,
				safety,
				plugs_app_settings,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'power_on_default', component: 'power_on_default' },
						{
							title: 'led_status_disable',
							component: 'led_status_disable_plug',
						},
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
